<template>
  <v-container fluid>
    <div class="faq-section">
      <div class="center">
        <h2>{{ $t("app.faq.title") }}</h2>

        <details>
          <summary>{{ $t("app.faq.q-install-android") }}</summary>
          <p class="detail-info" v-html="$t('app.faq.a-install-android')"></p>
          <img
            src="@/assets/images/android_installation_screenshot.png"
            alt="NeoParent installeren op een Android"
          />
        </details>
        <details>
          <summary>{{ $t("app.faq.q-install-ios") }}</summary>
          <p class="detail-info" v-html="$t('app.faq.a-install-ios')"></p>
          <img
            src="@/assets/images/ios_installation_screenshot.png"
            alt="NeoParent installeren op een IOS"
          />
        </details>

        <details>
          <summary>{{ $t("app.faq.q-mail-missing") }}</summary>
          <p class="detail-info" v-html="$t('app.faq.a-mail-missing')"></p>
        </details>

        <details>
          <summary>{{ $t("app.faq.q-mail-link") }}</summary>
          <p class="detail-info" v-html="$t('app.faq.a-mail-link')"></p>
        </details>

        <details>
          <summary>{{ $t("app.faq.q-delete-account") }}</summary>
          <p class="detail-info" v-html="$t('app.faq.a-delete-account')"></p>
        </details>
      </div></div
  ></v-container>
</template>

<script>
export default {
  name: "neoparent-faq",
  props: [],
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
details {
  margin-bottom: 2rem;
}

summary {
  cursor: pointer;
}

.detail-info {
  border-left: 3px solid #31b9be;
  margin-left: 4px;
  padding-left: 12px;
}

a {
  text-decoration: underline;
  color: #31b9be;
}

.install-icon {
  width: 14px;
  border-radius: 00;
}

img {
  margin: 0 auto;
  width: 70%;
}
</style>
